import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useAnimationControls, useReducedMotion } from "framer-motion";

const AMOUNTS = ["19,90 €", "49,00 €", "9,99 €", "129,90 €", "79,98 €", "27,00 €"];
const EMAILS = ["xxxxx@gmail.com", "xxxxxxx@outlook.fr", "xxxx@icloud.com"];
const TIMES = ["maintenant", "il y a 12 min", "il y a 1 h", "il y a 2 h"];

const PaymentContent = ({ id, position }) => (
  <>
    <div className="phone-notification-header">
      <span className="phone-app-icon" aria-hidden="true">s</span>
      <span className="phone-app-name">STRIPE</span>
      <span className="phone-notification-time" data-testid={`phone-notification-time-${id}`}>{TIMES[position]}</span>
    </div>
    <p className="phone-notification-title">Nouvelle vente</p>
    <p className="phone-notification-message" data-testid={`phone-notification-message-${id}`}>Tu as reçu {AMOUNTS[id % AMOUNTS.length]} de {EMAILS[id % EMAILS.length]}</p>
  </>
);

// Purely decorative simulation: no payment or network integration.
export const PhoneMockup = () => {
  const [tick, setTick] = useState(0);
  const reducedMotion = useReducedMotion();
  const vibration = useAnimationControls();
  const notifications = Array.from({ length: Math.min(tick + 1, 4) }, (_, i) => tick - i);

  useEffect(() => {
    const interval = setInterval(() => setTick((previous) => previous + 1), 2500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (reducedMotion) { vibration.set({ x: 0 }); return; }
    vibration.start({ x: [0, -2, 2, -2, 2, -2, 2, 0], transition: { duration: 0.3, ease: "linear" } });
  }, [tick, reducedMotion, vibration]);

  return (
    <figure className="phone-illustration" data-testid="hero-business-illustration" aria-label="Illustration de notifications de paiement simulées, aucun paiement réel">
      <div className="phone-stage" data-testid="phone-stage">
        <div className="phone-float" data-testid="phone-float">
          <motion.div animate={vibration} className="phone-shake" data-testid="phone-shake">
            <div className="phone-frame" data-testid="hero-phone-frame">
              <div className="phone-screen" data-testid="phone-screen" aria-hidden="true">
                <div className="phone-halo" />
                <div className="phone-island"><span /></div>
                <div className="phone-clock-area"><p className="phone-clock" data-testid="phone-clock">9:41</p><p className="phone-date">mardi 10 juin</p></div>
                <div className="phone-notifications" data-testid="phone-notifications">
                  <AnimatePresence mode="popLayout">
                    {notifications.map((id, position) => (
                      <motion.article key={id} layout={!reducedMotion} className="phone-notification" data-testid={`phone-notification-${id}`} data-slot={position}
                        initial={{ opacity: 0, y: reducedMotion ? 0 : "-120%" }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
                        transition={{ y: { type: "spring", duration: 0.5, bounce: 0.18 }, opacity: { duration: 0.25 }, layout: { type: "spring", duration: 0.5, bounce: 0.12 } }}>
                        <PaymentContent id={id} position={position} />
                      </motion.article>
                    ))}
                  </AnimatePresence>
                </div>
                <div className="phone-home-indicator" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <figcaption className="illustration-note" data-testid="phone-illustration-caption">Illustration</figcaption>
    </figure>
  );
};
